// src/components/SignGrid.js
import React from 'react';
import './SignGrid.css';
import { signosInfo } from '../../common/constants/signos'
import { useNavigate } from 'react-router-dom';


const SignGrid = () => {
    const navigate = useNavigate();
  
    const handleClick = (signo) => {
      navigate(`/frase/${signo}`);
    };
  
    return (
      <div className="sign-grid">
        {Object.entries(signosInfo).map(([signo, { img, dates }]) => (
          <div 
            className="sign-card-custom" 
            key={signo} 
            onClick={() => handleClick(signo)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => { if(e.key === 'Enter') handleClick(signo); }}
          >
            <img src={img} alt={signo} className="sign-img" />
            <h3>{signo.charAt(0).toUpperCase() + signo.slice(1)}</h3>
            <p className="sign-dates">{dates}</p>
          </div>
        ))}
      </div>
    );
  };

export default SignGrid;
